import React from 'react';
import { isChunkLoadError, reloadAfterChunkError } from './chunkLoadRecovery';

const RETRY_COUNT = 3;
const RETRY_DELAY = 1500;
function importWithRetry(importFn, retries = RETRY_COUNT) {
  return new Promise((resolve, reject) => {
    const attempt = (remaining) => {
      importFn()
        .then(resolve)
        .catch((err) => {
          if (remaining <= 1) {
            reject(err);
            if (isChunkLoadError(err)) {
              reloadAfterChunkError();
            }
            return;
          }
          setTimeout(() => attempt(remaining - 1), RETRY_DELAY);
        });
    };

    attempt(retries);
  });
}

export default function lazyWithRetry(importFn) {
  return React.lazy(() => importWithRetry(importFn));
}
